
import { Resource } from "src/app/core/jsonapi/resource";
import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Company } from "../../companies/_types/company";
import { Contract } from "../../companies/_types/contract";
import { ServiceType } from "./services-types";

export class ServiceTypeCompany extends Resource {
    public override type = 'serviceTypeCompanies';

    @prop()    
    @required()
    public companyId!: string;
    public company!: Company;

    @prop()    
    public serviceTypeId!: string;
    public serviceType!: ServiceType;

    @prop()    
    public contractId!: string | null;
    public contract!: Contract;

}